import React, { useState } from 'react';
import { UploadLendingJourneyIcon } from '../../assets/icons';
import { DropdownIcon } from '../../assets/icons';
import { LENDING_JOURNEY_REQUIREMENTS, NOTE_COLORS, LENDING_JOURNEY_NOTE } from '../../data';

const LendingJourneyDocumentNotes = () => {
    const [isExpanded, setIsExpanded] = useState(false);
    return (
        <>
            <section className="upload-lending-journey-docuement-section mb-0">
                <div className="title-box" onClick={() => setIsExpanded(!isExpanded)} style={{ cursor: 'pointer' }}>
                    <div className="icon-box">
                        <img src={UploadLendingJourneyIcon} alt="upload-lending-journey" />
                    </div>
                    <h4>Notes: Lending Journey Document Requirements</h4>
                    <span className={`dropdown-chevron-container ${isExpanded ? 'rotate' : 'no-rotate'}`}>
                        <img src={DropdownIcon} alt="dropdown" className="dropdown-chevron" />
                    </span>
                </div>
            </section>
            <div className="accordion-item">
                {isExpanded && (
                    <div className="ip-whitelisting-requirements">
                        <p className="requirements-subtitle">
                            {LENDING_JOURNEY_NOTE}
                        </p>
                        <div className="requirements-list">
                            {LENDING_JOURNEY_REQUIREMENTS.map((item, idx) => {
                                const color = NOTE_COLORS[idx % NOTE_COLORS.length];
                                return (
                                    <div
                                        className="requirement-item"
                                        key={idx}
                                        style={{
                                            borderLeft: `4px solid ${color.border}`,
                                            background: color.bg,
                                        }}
                                    >
                                        {item.title}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default LendingJourneyDocumentNotes;